import { Hr, Link, Text } from "@react-email/components";
import { Email as Styles } from "themes/styles";
import { Helpers } from "utils";

export const Footer = () => {
  return (
    <div style={Styles.footer.content}>
      <Text style={Styles.footer.text}>
        Visit{" "}
        <Link href={Helpers.generateInterpolatedUrl("")} style={Styles.link}>
          our website
        </Link>{" "}
        to learn more!
      </Text>
      {/* <Text style={Styles.footer.text}>
        Click to{" "}
        <Link href="#" style={Styles.link}>
          unsubscribe
        </Link>{" "}
        from mailing list.
      </Text> */}
      <Hr style={Styles.footer.divider} />
      <Text style={Styles.footer.text}>@2024 All rights reserved</Text>
    </div>
  );
};
